import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookAuthorForm } from "../BookAuthorForm";
import { CreateBookAuthorModalProps } from "./types";
import { useCreateBookAuthorModal } from "./controller";

export const CreateBookAuthorModal = React.memo(({ modalRef, onComplete }: CreateBookAuthorModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateBookAuthorModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_contributor_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <BookAuthorForm />
    </Modal>
  );
});
